package com.iregained.eventapp.components.sections.event_booking.styles

import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.UserSelect
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px

val CardContainerStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .padding(24.px)
            .borderRadius(12.px)
            .transition(Transition.of("all", 200.ms))
    }
}

val SlotPillStyle = CssStyle {
    base {
        Modifier
            .padding(topBottom = 12.px, leftRight = 16.px)
            .borderRadius(8.px)
            .cursor(Cursor.Pointer)
            .userSelect(UserSelect.None)
            .transition(Transition.of("all", 150.ms))
    }
    hover {
        Modifier.scale(1.02)
    }
}

val DateTabStyle = CssStyle {
    base {
        Modifier
            .padding(topBottom = 10.px, leftRight = 20.px)
            .borderRadius(20.px)
            .cursor(Cursor.Pointer)
            .transition(Transition.of("all", 150.ms))
    }
}